import React, {useState, useEffect} from 'react'

const OFFSET_MIN = 0
const OFFSET_MAX = 50

const OffsetPathPopover = ({value, onChange, onClose, onApply}) => {
    const [localValue, setLocalValue] = useState(value)

    useEffect(() => {
        setLocalValue(value)
    }, [value])

    const update = (num) => {
        const clamped = Math.min(OFFSET_MAX, Math.max(OFFSET_MIN, num))
        setLocalValue(clamped)
        onChange?.(clamped)
    }

    const sliderPct = ((localValue - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100

    return (
        <div className="OffsetPathPopover">
            <div className="OffsetPathPopover__Title">Offset path</div>
            <div className="OffsetPathPopover__Field">
                <div className="OffsetPathPopover__Row">
                    <span className="OffsetPathPopover__Label">Offset size</span>
                    <input
                        type="text"
                        className="OffsetPathPopover__Input"
                        value={`${localValue} px`}
                        onChange={(e) => {
                            const raw = e.target.value.replace(/\s*px\s*$/, '').trim()
                            const num = parseFloat(raw)
                            if (!Number.isNaN(num)) update(num)
                        }}
                        aria-label="Offset size"
                    />
                </div>
                <input
                    type="range"
                    className="OffsetPathPopover__Slider"
                    min={OFFSET_MIN}
                    max={OFFSET_MAX}
                    value={localValue}
                    onChange={(e) => update(Number(e.target.value))}
                    style={{
                        '--track-bg': `linear-gradient(to right, #007bff ${sliderPct}%, #dee2e6 ${sliderPct}%)`,
                    }}
                    aria-label="Offset size slider"
                />
            </div>
            <div className="OffsetPathPopover__Actions">
                <button type="button" className="OffsetPathPopover__CancelBtn" onClick={onClose}>
                    Cancel
                </button>
                <button type="button" className="OffsetPathPopover__ApplyBtn" onClick={() => onApply(localValue)}>
                    Apply
                </button>
            </div>
        </div>
    )
}

export default OffsetPathPopover
